export const ACCEPT_FILE_TYPES = ".doc, .docx, .jpg, .jpeg, .psd, .pdf, .txt, .xls, .xlsx, .png";

export enum MODAL_TYPES {
  CONFIRM = "CONFIRM",
}
